import { combineReducers } from "@reduxjs/toolkit";
import patientContext from "../../patient/state/patient-slice";
import userContext from "../../security/state/user-slice";
import adminUserContext from "../../admin/state/users/admin-slice";
import implementationSpecialistClientsContext from "../../implementation-specialist/state/clients/implementation-clients-slice";
import implementationFacilityContext from "../../implementation-specialist/state/facility/implementation-facility-slice";
import adminConfigurationContext from "../../admin-configuration/state/admin-configuration-slice";
import guestContext from "../../guest/state/guest-slice";
import metaData from "../../meta-data/state/meta-data-slice"
import metadataReducer from "../../security/state/metadata-slice";

const adminReducer = combineReducers({
  adminConfigurationContext: adminConfigurationContext,
  adminUserContext: adminUserContext,
});

const implementationReducer = combineReducers({
  implementationSpecialistClient: implementationSpecialistClientsContext,
  implementationFacility: implementationFacilityContext,
});


const rootReducer = combineReducers({
  patientContext: patientContext,
  userContext: userContext,
  adminContext: adminReducer,
  implementationContext: implementationReducer,
  guestContext: guestContext,
  metaData: metaData,
  metadata: metadataReducer,
});
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
